import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'number_contract_workers_workers_employed_third_party_who'

export const dataPointDefinition = {
  retracedId: 'number_contract_workers_workers_employed_third_party_who',
  name: 'Number of contract workers/ workers employed by third party who are not part of the production process:',
  description:
    '"Contract workers who are not part of the production process" refers to persons NOT working on/with the facility\'s product or directly involved in the operations of the facility and who are under contract with an organization other than the facility to work at the facility for a specified duration. ',
  meta: {
    slcpMeta: {
      key: 'fp-wor-12',
      number: 'FP-WOR-14',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {type: 'object', properties: {value: {type: 'string'}}, required: ['value']},
  externalIds: [{id: 'fp-wor-12', version: '1.7.0', provider: 'slcp'}],
  sortingId: 28990,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
